var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBringTokenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3654 6.39636H14.7253V7.99938H16.3654V6.39636Z",
    fill: "#FFD862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3618 11.1991H14.7217H13.0894H11.4493V12.8022V14.3975H9.81707H8.17699H6.54472V12.8022H8.17699H9.81707V11.1991V9.59613H8.17699V11.1991H6.54472H4.90463H3.27236H1.63227V9.59613H0V11.1991V12.8022H1.63227V14.3975H3.27236V16.0006H4.90463H6.54472H8.17699H9.81707H11.4493H13.0894H14.7217V14.3975H16.3618V12.8022H17.9941V11.1991V9.59613H16.3618V11.1991Z",
    fill: "#FFD862"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17915 6.39636H6.53906V7.99938H8.17915V6.39636Z",
    fill: "#FFD862"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7242 1.603V0H13.0919H11.4518H9.81957H8.17948H6.54721H4.90712H3.27485V1.603H1.63477V4.8014H3.27485H4.90712H6.54721H8.17948H9.81957H11.4518H13.0919H14.7242H16.3643V1.603H14.7242Z",
    fill: "#FFD862"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 3.19769H16.3601V4.80071H18.0001V3.19769Z",
    fill: "#FFD862"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64009 3.19769H0V4.80071H1.64009V3.19769Z",
    fill: "#FFD862"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBringTokenIcon);
export default __webpack_public_path__ + "static/media/bring-token-icon.3c4948ab81e2a8adfe8071281f1fe77d.svg";
export { ForwardRef as ReactComponent };